var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.81331 0 3.65328 0.351894 2.66658 1.01118C1.67989 1.67047 0.910851 2.60754 0.456725 3.7039C0.00259972 4.80026 -0.11622 6.00665 0.115291 7.17054C0.346802 8.33443 0.918247 9.40352 1.75736 10.2426C2.59648 11.0818 3.66557 11.6532 4.82946 11.8847C5.99335 12.1162 7.19975 11.9974 8.2961 11.5433C9.39246 11.0891 10.3295 10.3201 10.9888 9.33342C11.6481 8.34673 12 7.18669 12 6C12 4.4087 11.3679 2.88258 10.2426 1.75736C9.11742 0.632141 7.5913 0 6 0ZM5.255 3C5.255 2.80109 5.33402 2.61032 5.47467 2.46967C5.61532 2.32902 5.80609 2.25 6.005 2.25C6.20392 2.25 6.39468 2.32902 6.53533 2.46967C6.67598 2.61032 6.755 2.80109 6.755 3V6.445C6.755 6.54349 6.7356 6.64102 6.69791 6.73201C6.66022 6.82301 6.60498 6.90568 6.53533 6.97533C6.46569 7.04497 6.38301 7.10022 6.29201 7.13791C6.20102 7.1756 6.10349 7.195 6.005 7.195C5.90651 7.195 5.80898 7.1756 5.71799 7.13791C5.627 7.10022 5.54432 7.04497 5.47467 6.97533C5.40503 6.90568 5.34978 6.82301 5.31209 6.73201C5.2744 6.64102 5.255 6.54349 5.255 6.445V3ZM6 9.75C5.82991 9.75 5.66364 9.69956 5.52221 9.60506C5.38079 9.51056 5.27056 9.37625 5.20547 9.21911C5.14037 9.06196 5.12334 8.88904 5.15653 8.72222C5.18971 8.5554 5.27162 8.40216 5.39189 8.28189C5.51216 8.16161 5.6654 8.07971 5.83222 8.04652C5.99905 8.01334 6.17197 8.03037 6.32911 8.09546C6.48625 8.16055 6.62057 8.27078 6.71507 8.41221C6.80956 8.55363 6.86 8.71991 6.86 8.89C6.86 9.11808 6.7694 9.33683 6.60811 9.49811C6.44683 9.65939 6.22809 9.75 6 9.75Z",
    fill: "#E20238"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.9a4f709bf9036b38eaedc7dcccbb5061.svg";
export { ForwardRef as ReactComponent };